module.exports = __webpack_public_path__ + "img/library-create-icon.49e5647c.svg";